(function () {
  'use strict';

  const MOBILE_WIDTH = 990;
  const TOP_THRESHOLD = 30;

  let ticking = false;
  let vaveleAbortController = null;

  function isMobile() {
    return window.innerWidth < MOBILE_WIDTH;
  }

  function isCollectionProductPage() {
    if (!document.body.classList.contains('template-collection')) return false;

    const path = window.location.pathname;
    if (path === '/collections' || path === '/collections/') return false;

    return true;
  }

  function getScrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function updateHeaderHeight() {
    const header =
      document.querySelector('#shopify-section-header .header-wrapper') ||
      document.querySelector('#shopify-section-header .header') ||
      document.querySelector('#shopify-section-header');

    if (!header) return;

    const height = Math.round(header.getBoundingClientRect().height);

    if (height > 0) {
      document.documentElement.style.setProperty(
        '--vavele-mobile-header-height',
        height + 'px'
      );
    }
  }

  function setPageState() {
    if (!isMobile() || !isCollectionProductPage()) {
      document.body.classList.remove('vavele-at-top', 'vavele-scrolled');
      ticking = false;
      return;
    }

    const y = getScrollY();

    if (y <= TOP_THRESHOLD) {
      document.body.classList.add('vavele-at-top');
      document.body.classList.remove('vavele-scrolled');
    } else {
      document.body.classList.remove('vavele-at-top');
      document.body.classList.add('vavele-scrolled');
    }

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(setPageState);
    }
  }

  function openVaveleSheet() {
    const sheet = document.querySelector('[data-vavele-bottom-sheet]');
    if (!sheet) return;

    document.body.classList.add('vavele-sheet-open', 'vavele-filters-open');
    sheet.setAttribute('aria-hidden', 'false');
  }

  function closeVaveleSheet() {
    const sheet = document.querySelector('[data-vavele-bottom-sheet]');
    if (!sheet) return;

    document.body.classList.remove('vavele-sheet-open', 'vavele-filters-open');
    sheet.setAttribute('aria-hidden', 'true');
  }

  function replaceProductGridFromUrl(targetUrl, options) {
    options = options || {};

    if (!targetUrl || targetUrl === '#') return;

    if (vaveleAbortController) {
      vaveleAbortController.abort();
    }

    vaveleAbortController = new AbortController();

    const gridContainer = document.querySelector('#ProductGridContainer');
    const currentSheetBody = document.querySelector('[data-vavele-sheet-body]');
    const cachedScrollTop = currentSheetBody ? currentSheetBody.scrollTop : 0;
    const sheetWasOpen =
      document.body.classList.contains('vavele-sheet-open') ||
      document.body.classList.contains('vavele-filters-open');

    if (gridContainer) {
      gridContainer.classList.add('vavele-grid-loading', 'vavele-loading');
    }

    fetch(targetUrl, {
      method: 'GET',
      credentials: 'same-origin',
      signal: vaveleAbortController.signal,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Network response was not ok: ' + response.status);
        }

        return response.text();
      })
      .then(function (html) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');

        const newGrid = parsed.querySelector('#ProductGridContainer');
        const currentGrid = document.querySelector('#ProductGridContainer');

        if (!newGrid || !currentGrid) {
          console.warn('[VAVELE] Missing grid in AJAX response. Full reload blocked:', targetUrl);
return;
        }

        currentGrid.innerHTML = newGrid.innerHTML;

        const currentStickyFilters = document.querySelector('[data-vavele-sticky-filters]');
        const newStickyFilters = parsed.querySelector('[data-vavele-sticky-filters]');

        if (currentStickyFilters && newStickyFilters) {
          currentStickyFilters.innerHTML = newStickyFilters.innerHTML;
        }

        const liveSheetBody = document.querySelector('[data-vavele-sheet-body]');
        const newSheetBody = parsed.querySelector('[data-vavele-sheet-body]');

        if (liveSheetBody && newSheetBody) {
          liveSheetBody.innerHTML = newSheetBody.innerHTML;
          liveSheetBody.scrollTop = cachedScrollTop;
        }

        if (history.pushState && !options.skipHistory) {
          window.history.pushState({ vavele: true }, '', targetUrl);
        }

        if (sheetWasOpen) {
          openVaveleSheet();
        }

        document.dispatchEvent(new CustomEvent('vavele:collection-updated'));
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;

        console.error('[VAVELE] AJAX filter failed:', error);
        window.location.href = targetUrl;
      })
      .finally(function () {
        const updatedGrid = document.querySelector('#ProductGridContainer');

        if (updatedGrid) {
          updatedGrid.classList.remove('vavele-grid-loading', 'vavele-loading');
        }

        vaveleAbortController = null;
      });
  }


function buildVaveleSheetUrl() {
  const sheetBody = document.querySelector('[data-vavele-sheet-body]');
  if (!sheetBody) return window.location.pathname;

  const params = new URLSearchParams();

  // CHECKBOX: materiał, typ, kolor, grawer, prezent
  sheetBody
    .querySelectorAll('[data-vavele-staged-option][data-filter-type="checkbox"].is-active')
    .forEach(function (tile) {
      const param = tile.getAttribute('data-param');
      const value = tile.getAttribute('data-value');

      if (param && value) {
        params.append(param, value);
      }
    });

  // CENA: tylko jeden aktywny zakres
  const activePrice = sheetBody.querySelector(
    '[data-vavele-staged-option][data-filter-type="price"].is-active'
  );

  if (activePrice) {
    const gte = activePrice.getAttribute('data-price-gte');
    const lte = activePrice.getAttribute('data-price-lte');

    if (gte) params.set('filter.v.price.gte', gte);
    if (lte) params.set('filter.v.price.lte', lte);
  }

  // SORTOWANIE: na później, kiedy sort będzie selectem albo dostanie data-sort-value
  const activeSort = sheetBody.querySelector(
    '[data-vavele-staged-option][data-filter-type="sort"].is-active'
  );

  if (activeSort) {
    const sortValue = activeSort.getAttribute('data-sort-value');
    if (sortValue) {
      params.set('sort_by', sortValue);
    }
  }

  const query = params.toString();
  return query ? window.location.pathname + '?' + query : window.location.pathname;
}

function applyVaveleSheetFilters() {
  const targetUrl = buildVaveleSheetUrl();
  const currentUrl = window.location.pathname + window.location.search;

  closeVaveleSheet();

  if (targetUrl === currentUrl) return;

  replaceProductGridFromUrl(targetUrl);
}

function bindDelegatedEvents() {
  document.addEventListener('click', function (event) {
    const openButton = event.target.closest('[data-vavele-open-filters], [data-vavele-open-sheet]');

    if (openButton) {
      event.preventDefault();
      event.stopPropagation();
      openVaveleSheet();
      return;
    }

    const closeButton = event.target.closest('[data-vavele-sheet-close]');

    if (closeButton) {
      event.preventDefault();
      event.stopPropagation();

      // Klik w overlay / pustą przestrzeń = zastosuj staged filtry
      if (closeButton.classList.contains('vavele-sheet__overlay')) {
        applyVaveleSheetFilters();
        return;
      }

      // Klik w X = tylko zamknij, bez filtrowania
      closeVaveleSheet();
      return;
    }

    const applyButton = event.target.closest('[data-vavele-apply-sheet-filters]');

    if (applyButton) {
      event.preventDefault();
      event.stopPropagation();
      applyVaveleSheetFilters();
      return;
    }

    // Opcje w bottom sheet — tylko lokalne zaznaczanie, bez AJAX po każdym kliknięciu
    const sheetOption = event.target.closest('[data-vavele-staged-option]');

    if (sheetOption && sheetOption.closest('[data-vavele-sheet-body]')) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (sheetOption.classList.contains('is-disabled')) return;

      const type = sheetOption.getAttribute('data-filter-type');
      const group = sheetOption.closest('.vavele-sheet__group');

      // Cena = radio + możliwość odznaczenia drugim kliknięciem
      if (type === 'price' && group) {
        const wasActive = sheetOption.classList.contains('is-active');

        group.querySelectorAll('.vavele-sheet__tile.is-active').forEach(function (tile) {
          tile.classList.remove('is-active');
          tile.setAttribute('aria-pressed', 'false');
        });

        if (!wasActive) {
          sheetOption.classList.add('is-active');
          sheetOption.setAttribute('aria-pressed', 'true');
        }

        return;
      }

      // Sort = radio, zawsze jedna opcja aktywna
      if (type === 'sort' && group) {
        group.querySelectorAll('.vavele-sheet__tile.is-active').forEach(function (tile) {
          tile.classList.remove('is-active');
          tile.setAttribute('aria-pressed', 'false');
        });

        sheetOption.classList.add('is-active');
        sheetOption.setAttribute('aria-pressed', 'true');

        return;
      }

      // Checkbox = multi-select
      if (type === 'checkbox') {
        sheetOption.classList.toggle('is-active');
        sheetOption.setAttribute(
          'aria-pressed',
          sheetOption.classList.contains('is-active') ? 'true' : 'false'
        );

        return;
      }
    }

    // Sticky chip bar poza bottom sheetem — instant AJAX
    const ajaxLink = event.target.closest(
      '[data-vavele-ajax-filter], [data-vavele-ajax-link], [data-vavele-filter-option]'
    );

    if (ajaxLink && ajaxLink.tagName === 'A') {
      // Ważne: jeżeli to jednak link ze środka sheetu, nie puszczamy AJAX
      if (ajaxLink.closest('[data-vavele-sheet-body]')) return;

      const href = ajaxLink.getAttribute('href');

      if (!href || href === '#') return;

      event.preventDefault();
      event.stopPropagation();

      replaceProductGridFromUrl(href);
      return;
    }
  });
}

  function onResize() {
    updateHeaderHeight();
    setPageState();
  }

  function init() {
    if (!isCollectionProductPage()) return;

    updateHeaderHeight();
    setPageState();
    bindDelegatedEvents();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', onResize);

    window.addEventListener('popstate', function () {
      replaceProductGridFromUrl(window.location.href, { skipHistory: true });
    });

    window.addEventListener('load', function () {
      updateHeaderHeight();
      setPageState();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();